import { useState, useEffect } from "react";
import {Button,Tag,App} from "antd";
import {DeleteOutlined,EditOutlined,MinusOutlined,PlusOutlined} from "@ant-design/icons";
import "./SelectedItem.scss";
import { sendBillAction } from "../../../components/action/SendBillAction";
import CustomizeOrder from "../../../components/customizeorder/CustomizeOrder";
// import { useStore } from "../../../components/globalstate/GlobalState";
import { socket } from "../../../components/socket/Sockets";

const colors = ["pink", "green", "blue", "purple"];

const SelectedItem = ({ totalItems, filteredToppings,billId }) => {
  const [coffeeItems, setCoffeeItems] = useState([]);
  const { message } = App.useApp();

  const [isToppingModalOpen, setIsToppingModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [size, setSize] = useState("");
  const [sugar, setSugar] = useState("");
  const [ice, setIce] = useState("");
  const [note, setNote] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedToppings, setSelectedToppings] = useState([]);

// const idFromStore = useStore((state) => state.id);
// const idBill = idFromStore ?? billId;
const idBill = billId;

// console.log(billId)

  
  useEffect(() => {
    const user = localStorage.getItem("cashier");

    socket.emit("join-bill", idBill, user);

    // const handleJoined = (data) => console.log("✅ Joined bill:", data);
    const handleBillUpdated = (updatedBill) => {
      const billObj = Array.isArray(updatedBill)
        ? updatedBill[0]
        : updatedBill;
      setCoffeeItems(billObj?.Item_Selected || []);
      totalItems(billObj);  
      //  console.log("test trigger back bill:", billObj);
    };

   


    // socket.on("joined-bill", handleJoined);
    socket.on("bill-updated", handleBillUpdated);

    return () => {
      // socket.off("joined-bill", handleJoined);
      socket.off("bill-updated", handleBillUpdated);
    };
  }, [idBill, totalItems]);



  const handleEdit = (item) => {
    setCurrentItem(item);
    setSize(item.size || "");
    setSugar(item.sugar || "");
    setIce(item.ice || "");
    setNote(item.note || "");
    setSelectedToppings(item.toppings || []);
    setIsToppingModalOpen(true);
  };

  const handleConfirm = () => {
    if (!currentItem) return;

    const updatedItem = {
      ...currentItem,size,sugar,ice,note,
      topping: selectedToppings,
    };

    sendBillAction("update-item", updatedItem, {}, message);
    setIsToppingModalOpen(false);
  };



  return (
    <div className="coffee-cart">
      {coffeeItems.map((item, itemIndex) => {
        const itemColor = colors[itemIndex % colors.length];

        return (
          <div key={itemIndex}>

            {item.type !== "Topping" ?
              <div className="item-selected">
                <div className="coffee-card-content">
                  <div className="frame-image-item-selected">
                    <img src={item.img} alt={item.name} className="coffee-img" />
                    <p className="coffee-price">${item?.price?.toFixed(2)}</p>
                  </div>

                  <div className="coffee-info">
                    <h4 className="coffee-name">{item.name}</h4>
                    <p className="coffee-meta">
                      Size: {item.size} &nbsp;
                      {item.sugar ? `Sugar: ${item.sugar}` : ""} &nbsp;
                      {item.ice ? `Ice: ${item.ice}` : ""}
                    </p>
                    <p className="coffee-meta">Note: {item.note || ""}</p>
                  </div>
                </div>

                <div className="selected-item-actions">
                  <div>
                    {item.toppings?.length > 0 && (
                      <Tag color={itemColor} style={{ marginRight: "30px" }}>
                        Topping
                      </Tag>
                    )}

                    <Button
                      type="primary"
                      danger
                      icon={<DeleteOutlined />}
                      className="delete-btn"
                      onClick={() =>
                        sendBillAction("delete-item", { ...item }, {}, message)
                      }
                    />
                  </div>

                  <div className="bottom-actions">
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      className="action-btn"
                      onClick={() => handleEdit(item)}
                    />

                    <div className="quantity-control">
                      <Button
                        onClick={() =>
                          sendBillAction("subtract-item", { ...item, quantity: 1 }, {}, null)
                        }
                        icon={<MinusOutlined />}
                        className="qty-btn"
                      />
                      <span className="qty-value">{item.quantity}</span>
                      <Button
                        onClick={() =>
                          sendBillAction("add-item", { ...item, quantity: 1 }, {}, message)
                        }
                        icon={<PlusOutlined />}
                        className="qty-btn"
                      />
                    </div>
                  </div>
                </div>
              </div> :
              (
                <div className="toppings-list">
                  <div className="topping-card">
                    <span className="frame-name-topping">{item.name}</span>
                    <span className="frame-price-topping">${item.price}</span>

                    <div className="quantity-control">
                      <Button
                        onClick={() =>
                          sendBillAction(
                            "subtract-item",
                            {...item,
                              quantity: 1},
                            {},
                            null
                          )
                        }
                        icon={<MinusOutlined />}
                        className="qty-btn"
                      />
                      <span className="qty-value">{item.quantity}</span>
                      <Button
                        onClick={() =>
                          sendBillAction(
                            "add-item",
                            { ...item, quantity: 1 },
                            {},
                            message
                          )
                        }
                        icon={<PlusOutlined />}
                        className="qty-btn"
                      />
                      <Button
                        danger
                        type="primary"
                        size="s"
                        onClick={() =>
                          sendBillAction("delete-item", { ...item }, {}, message)
                        }
                        icon={<DeleteOutlined />}
                      />
                    </div>
                  </div>
                </div>
              )}

            {item.toppings?.length > 0 && (
              <div className="toppings-list">
                {item.toppings.map((top, index) => (
                  <div key={top.id} className="topping-card">
                    <span className="frame-name-topping">{top.name}</span>
                    <span className="frame-price-topping">${top.price}</span>
                    <Tag color={itemColor}>Topping-{index + 1}</Tag>

                    <div className="quantity-control">
                      <Button
                        onClick={() =>
                          sendBillAction("subtract-topping", {
                            id: item.id,
                            customize: item.customize,
                            name: item.name,
                            toppings: [{ id: top.id, name: top.name, quantity: 1 }],
                          }, {}, message)
                        }
                        icon={<MinusOutlined />}
                        className="qty-btn"
                      />
                      <span className="qty-value">{top.quantity}</span>
                      <Button
                        onClick={() =>
                          sendBillAction("add-topping", {
                            id: item.id,
                            customize: item.customize,
                            name: item.name,
                            toppings: [{ id: top.id, name: top.name, quantity: 1 }],
                          }, {}, message)
                        }
                        icon={<PlusOutlined />}
                        className="qty-btn"
                      />
                      <Button
                        danger
                        type="primary"
                        size="s"
                        onClick={() =>
                          sendBillAction("delete-topping", {
                            id: item.id,
                            customize: item.customize,
                            name: item.name,
                            toppings: [{ id: top.id, name: top.name }],
                          }, {}, message)
                        }
                        icon={<DeleteOutlined />}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}

          </div>
        );
      })}



      <CustomizeOrder
        open={isToppingModalOpen}
        setOpen={setIsToppingModalOpen}
        item={currentItem}
        toppings={filteredToppings}
        selectedToppings={selectedToppings}
        setSelectedToppings={setSelectedToppings}
        size={size}
        setSize={setSize}
        sugar={sugar}
        setSugar={setSugar}
        ice={ice}
        setIce={setIce}
        note={note}
        setNote={setNote}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        onConfirm={handleConfirm}
        onCancel={() => setIsToppingModalOpen(false)}
      />
    </div>
  );
};

export default SelectedItem;
